<!--保养记录：保养记录-->
<template>
  <div class="app-container">
    <!--页头-->
    <div class="page-container">
      <div class="section">
        <div class="control-box">
          <div class="cb-left">
            <h1 style="font-size: 20px;">{{ $t('maintenance_record') }}</h1>
          </div>
        </div>
        <div class="table-box">
          <div class="control-search">
            <!--添加按钮-->
            <div class="cb-left">
              <span style="font-size:14px">{{ $t('deviceName') }} </span>
              <el-select
                  v-model="maintainanceForm.deviceId"
                  clearable
                  :placeholder="$t('xuanzeDevice')"
                  style="width: 200px;margin-left:10px"
              >
                <el-option
                    v-for="item in option1"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
              <span style="margin-left:30px;font-size:14px">{{ $t('maintenance_type') }} </span>
              <el-select
                  v-model="maintainanceForm.type"
                  clearable
                  :placeholder="$t('select_maintenance_type')"
                  style="width: 200px;margin-right:10px;margin-left: 10px"
              >
                <el-option
                    v-for="item in option2"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                  class="control-item"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleSearch"
              >
                {{ $t('search') }}
              </el-button>
              <el-button :loading="loading" v-if="roleType === 3 || roleType === 2" type="primary" @click="handleExport()" >
                {{ $t('BatchExport') }}
              </el-button>
            </div>
          </div>
          <el-tabs v-model="activeName" type="card" @tab-click="getDeviceListById">
            <el-tab-pane :label="$t('all')" name="first">
              <div class="table-box">
                <el-table
                    :data="maintainanceData"
                    border
                    highlight-current-row
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" v-if="roleType === 3 || roleType === 2" model="" width="50" ></el-table-column>
                  <el-table-column :label="$t('deviceName')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.deviceName }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('device_type')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.infoName }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('maintenance_type')" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{scope.row.type === 1 ? $t('day_maintainance') : scope.row.type === 2 ? $t('weeks_maintainance') : scope.row.type === 3 ? $t('months_maintainance') :scope.row.type === 30 ? $t('half_months_maintainance') :scope.row.type === 4 ? $t('quarter_maintainance') :scope.row.type === 5 ? $t('half_year_maintainance') : $t('year_maintainance')}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column :label="$t('device_state')" align="center" width="150">
                    <template slot-scope="scope">
                      <div style="color: #EA000E " v-if="scope.row.status === 0">{{ $t('not_maintained') }}</div>
                      <div style="color: #37C239 " v-if="scope.row.status === 1">{{ $t('maintenance_completed')}}</div>
                      <div style="color: #37C239 " v-if="scope.row.status === 2">{{ $t('inspection_completed') }}</div>
                      <div style="color: #F7B515 " v-if="scope.row.status === 3">{{ $t('cancelling') }}</div>
                      <div style="color: #999999 " v-if="scope.row.status === 4">{{ $t('cancelled') }}</div>
                      <div style="color: #409EFF " v-if="scope.row.status === 5">{{ $t('overtime_cancellation') }}</div>
                      <div style="color: #409EFF " v-if="scope.row.status === 7">{{ $t('inspection_overtime_cancellation') }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('maintenance_time')" align="center" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.startTime }}
                    </template>
                  </el-table-column>
                  <!--操作-->
                  <el-table-column :label="$t('caozuo')" header-align="center" align="center" width="240">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="checkReplacement(scope.row)">
                        {{ $t('device_view') }}
                      </el-button>
                      <el-button type="primary" v-if="roleType === 3 || roleType === 2" size="mini" plain @click="handleExport(scope.row.id)">
                        {{ $t('export') }}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--分页-->
              <div class="pagination-box">
                <el-pagination
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="maintainanceForm.count"
                    :total="maintainanceCount"
                    :current-page="maintainanceForm.page + 1"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('incomplete')" name="second">
              <div class="table-box">
                <el-table
                    :data="maintainanceData"
                    border
                    highlight-current-row
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" v-if="roleType === 3 || roleType === 2" model="" width="50" ></el-table-column>
                  <el-table-column :label="$t('deviceName')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.deviceName }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('device_type')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.infoName }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('maintenance_type')" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{scope.row.type === 1 ? $t('day_maintainance') : scope.row.type === 2 ? $t('weeks_maintainance') : scope.row.type === 3 ? $t('months_maintainance') :scope.row.type === 30 ? $t('half_months_maintainance') :scope.row.type === 4 ? $t('quarter_maintainance') :scope.row.type === 5 ? $t('half_year_maintainance') : $t('year_maintainance')}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column :label="$t('device_state')" align="center" width="150">
                    <template slot-scope="scope">
                      <div style="color: #EA000E " v-if="scope.row.status === 0">{{ $t('not_maintained') }}</div>
                      <div style="color: #37C239 " v-if="scope.row.status === 1">{{ $t('maintenance_completed')}}</div>
                      <div style="color: #37C239 " v-if="scope.row.status === 2">{{ $t('inspection_completed') }}</div>
                      <div style="color: #F7B515 " v-if="scope.row.status === 3">{{ $t('cancelling') }}</div>
                      <div style="color: #999999 " v-if="scope.row.status === 4">{{ $t('cancelled') }}</div>
                      <div style="color: #409EFF " v-if="scope.row.status === 5">{{ $t('overtime_cancellation') }}</div>
                      <div style="color: #409EFF " v-if="scope.row.status === 7">{{ $t('inspection_overtime_cancellation') }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('maintenance_time')" align="center" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.startTime }}
                    </template>
                  </el-table-column>
                  <!--操作-->
                  <el-table-column :label="$t('caozuo')" header-align="center" align="center" width="240">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="checkReplacement(scope.row)">
                        {{ $t('device_view') }}
                      </el-button>
                      <el-button type="primary" size="mini" v-if="roleType === 3 || roleType === 2" plain @click="handleExport(scope.row.id)">
                        {{ $t('export') }}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--分页-->
              <div class="pagination-box">
                <el-pagination
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="maintainanceForm.count"
                    :total="maintainanceCount"
                    :current-page="maintainanceForm.page + 1"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('finish')" name="three">
              <div class="table-box">
                <el-table
                    :data="maintainanceData"
                    border
                    highlight-current-row
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" v-if="roleType === 3 || roleType === 2" model="" width="50" ></el-table-column>
                  <el-table-column :label="$t('deviceName')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.deviceName }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('device_type')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.infoName }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('maintenance_type')" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{scope.row.type === 1 ? $t('day_maintainance') : scope.row.type === 2 ? $t('weeks_maintainance') : scope.row.type === 3 ? $t('months_maintainance') :scope.row.type === 30 ? $t('half_months_maintainance') :scope.row.type === 4 ? $t('quarter_maintainance') :scope.row.type === 5 ? $t('half_year_maintainance') : $t('year_maintainance')}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column :label="$t('device_state')" align="center" width="150">
                    <template slot-scope="scope">
                      <div style="color: #EA000E " v-if="scope.row.status === 0">{{ $t('not_maintained') }}</div>
                      <div style="color: #37C239 " v-if="scope.row.status === 1">{{ $t('maintenance_completed')}}</div>
                      <div style="color: #37C239 " v-if="scope.row.status === 2">{{ $t('inspection_completed') }}</div>
                      <div style="color: #F7B515 " v-if="scope.row.status === 3">{{ $t('cancelling') }}</div>
                      <div style="color: #999999 " v-if="scope.row.status === 4">{{ $t('cancelled') }}</div>
                      <div style="color: #409EFF " v-if="scope.row.status === 5">{{ $t('overtime_cancellation') }}</div>
                      <div style="color: #409EFF " v-if="scope.row.status === 7">{{ $t('inspection_overtime_cancellation') }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('maintenance_time')" align="center" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.startTime }}
                    </template>
                  </el-table-column>
                  <!--操作-->
                  <el-table-column :label="$t('caozuo')" header-align="center" align="center" width="240">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="checkReplacement(scope.row)">
                        {{ $t('device_view') }}
                      </el-button>
                      <el-button type="primary" size="mini" v-if="roleType === 3 || roleType === 2" @click="handleExport(scope.row.id)" plain >
                        {{ $t('export') }}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--分页-->
              <div class="pagination-box">
                <el-pagination
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="maintainanceForm.count"
                    :total="maintainanceCount"
                    :current-page="maintainanceForm.page + 1"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/api';
import {base64toFile} from '@/utils/file';
import moment from "moment";

export default {
  name: "maintainance",
  data() {
    return {
      abnormal: [],// 异常提报
      option1: [],
      option2: [
        {text: this.$t('all_maintenance'), value: -1},
        {text: this.$t('day_maintainance'), value: 1},
        {text: this.$t('weeks_maintainance'), value: 2},
        {text: this.$t('half_months_maintainance'), value: 30},
        {text: this.$t('months_maintainance'), value: 3},
        {text: this.$t('quarter_maintainance'), value: 4},
        {text: this.$t('half_year_maintainance'), value: 5},
        {text: this.$t('year_maintainance'), value: 6},
      ],
      maintainanceForm: {
        count: 10,
        page: 0,
        status: -1,
        type: -1,
        date: null,
        printType: null,
        deviceId: localStorage.getItem('deviceId') === '-1' ? '' : localStorage.getItem('deviceId')
      },
      abnormalCount: 0,
      maintainanceData: [],// 定期更换
      loading: false,
      maintainanceCount: 0,
      totalCount: 0,
      faultList: [],// 异常提报
      exportData: '',
      faultForm: {
        page: 1,
        count: 10,
        type: 3
      },
      faultCount: 0,
      activeName: 'first',
      rules: {},
    };
  },
  computed: {
    roleType() {
      // this.value1 = localStorage.getItem('deviceId')
      return this.$store.state.userInfo.roleType
    },
  },
  created() {
    console.log(localStorage.getItem('deviceId'))
    console.log(this.roleType)
    this.activeName = this.$store.state.mainForm.activeName
    this.maintainanceForm.status = this.$store.state.mainForm.status
    this.maintainanceForm.page = this.$store.state.mainForm.page
    this.maintainanceForm.count = this.$store.state.mainForm.count
    this.maintainanceForm.deviceId = this.$store.state.mainForm.deviceId
    if (!this.$store.state.mainForm.deviceId) {
      this.maintainanceForm.deviceId = localStorage.getItem('deviceId') === '-1' ? '' : localStorage.getItem('deviceId')
    }
    this.maintainanceForm.type = this.$store.state.mainForm.type
    if (!this.maintainanceForm.type) {
      this.maintainanceForm.type = -1
    }
    this.getList()
    this.getDevice()
  },
  mounted() {

  },
  methods: {
    handleSelectionChange(val) {
      this.exportData = val.map(item => item.id).join(',');
      console.log(this.exportData);
    },
    handleExport(id) {
      this.loading = true
      let ids = ''
      if (id) {
        ids = id
      } else {
        ids = this.exportData
      }
      if (!this.exportData && !id) {
        this.$message({
          message: this.$t('maintenance_records'),
          showClose: true,
          type: 'warning',
        });
        this.loading = false
        return
      }
      API.maintainExport({id:ids}).then(res => {
        console.log(res)
        if (res.message.success) {
          window.open(res.message.data)
          this.loading = false
          this.$message({
            message: this.$t('export_success'),
            showClose: true,
            type: 'success',
          });
        }

      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      if (!this.maintainanceForm.type) {
        this.maintainanceForm.type = -1
      }
      this.maintainanceForm.page = 0
      this.getList()
    },
    getList() {
      console.log(this.maintainanceForm)
      if (!this.maintainanceForm.type) {
        this.maintainanceForm.type = -1
      }
      API.listmaintainSubmit(this.maintainanceForm).then(res => {
        this.maintainanceData = res.message.data.list
        this.maintainanceCount = res.message.data.totalCount
      })
    },
    getDevice() {
      API.deviceList().then(res => {
        this.option1.push(...res.message.data)
        this.option1.unshift({name: this.$t('alldevice'), id: ''})
      })
    },
    dateFmt(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm')
    },
    // 查看
    checkReplacement(row) {
      this.$store.commit('mainFormSet', {type: this.maintainanceForm.type,deviceId:this.maintainanceForm.deviceId,page: this.maintainanceForm.page,count: this.maintainanceForm.count, activeName: this.activeName,status:this.maintainanceForm.status});
      this.$router.push({path: 'maintenDetail', query: {id: row.id,type: 'list'}});
    },
    back() {
      this.$router.go(-1);
    },
    getDeviceListById(tab) {
      this.maintainanceForm.count = 10
      this.maintainanceForm.page = 0
      if (tab.name === 'first') {
        this.maintainanceForm.status = -1
        this.getList()
      } else if(tab.name === 'second') {
        this.maintainanceForm.status = 0
        this.getList()
      }else {
        this.maintainanceForm.status = 1
        this.getList()
      }
    },
    handleSizeChange(val) {
      this.maintainanceForm.count = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.maintainanceForm.page = val - 1;
      this.getList();
    },
    handleSizeChange2(val) {
      this.abnormalForm.count = val;
      this.getAbnormal();
    },
    handleCurrentChange2(val) {
      this.abnormalForm.page = val;
      this.getAbnormal();
    },
    handleSizeChange3(val) {
      this.faultForm.count = val;
      this.getFault();
    },
    handleCurrentChange3(val) {
      this.faultForm.page = val;
      this.getFault();
    },
  },
};
</script>
<style scoped lang="scss">
.table-box {
  position: relative;
}

::v-deep .dialog-footer {
  text-align: right;
}

::v-deep .el-tabs__active-bar {
  height: 2px;
  background-color: #F3A100;
}

.control-item {

}

.control-btn {
  text-align: right;
  position: absolute;
  right: 0px;
  top: -0px;
  z-index: 9999;
}

.control-box1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  position: absolute;
  right: 21px;
  top: 127px;
  z-index: 999;
}

.btn {
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  width: 100%;
  border-radius: 4px;
  line-height: 1;
  height: 40px;
  padding: 12px 10px 0px 15px;
  color: #cccfd6;
  cursor: pointer;
}

.person {
  margin-bottom: 20px;
}

.history {
  text-align: right;
}

.record {
  margin-bottom: 0px;

  img {
    width: 15px;
    margin-right: 10px;
  }

  span {
    //display: inline-block;
    text-align: right;
    width: 100%;
    cursor: pointer;
  }
}

.pic-and-video-wrapper {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .btn {
    width: 90px;
    height: 90px;
    margin-top: 10px;
    background-color: #f1f1f1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    border: 0;
    padding: 0;

    img {
      width: 20px;
      height: 20px;
    }

    span {
      margin-top: 5px;
      font-size: 13px;
      color: grey;
    }

    .closeVideo-btn {
      margin-top: 8px;
    }
  }
}

.preview {
  width: 90px;
  height: 90px;
  margin-top: 10px;
  margin-right: 10px;
  position: relative;

  img {
    position: absolute;
    width: 90px;
    height: 90px;
  }

  .van-btton {
    position: absolute;
    right: 0;
    font-size: 20px;
    //top: -15px;
    background: #fff;
    padding: 0;
    color: #f56c6c;
  }
}

.voice {
  width: 100%;
  height: 34px;
  border-radius: 17px;
  background-color: #f1f1f1;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 22px;
    height: 22px;
  }
}

.video-label {
  width: 100%;
  height: 34px;
  border-radius: 17px;
  background-color: lightgrey;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
  font-size: 13px;
  color: grey;

  .close-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.item {
  padding: 8px 10px;

  img {
    width: 32px;
    margin-right: 10px;
  }
}

.item:hover {
  background-color: #FFFAED;
}

.list-item {
  display: flex;
  justify-content: space-between;
  color: #9F9F9F;
  font-size: 14px;

  .name {
    color: #3D3D3D;
    font-size: 16px;
    margin-bottom: 10px;
  }

  padding: 15px 0;
  border-bottom: 1px solid #F1F1F1;
}

.item-left {
  display: flex;

  img {
    width: 56px;
    margin-right: 15px;
  }
}

.control-search {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 0 20px;
  //项
  .control-item {
    display: inline-block;

    + .control-item {
      margin-left: 10px;
    }
  }

  //左栏
  .cb-left {
  }

  //右栏
  .cb-right {
  }

  //表单项
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>

